import React from 'react'
import { KeycloakProvider } from '@react-keycloak/web'
import { Provider } from 'react-redux'
import { useHistory, matchPath } from 'react-router-dom'
import { useFirebaseLogin, useRemindPasswordLater } from 'hooks'
import { Drawer, Modal } from 'components'
import { JWT_TOKEN_KEY, AUTH_SUCCESS_EVENT, ROUTES, ORIGIN } from 'app-constants'
import { Routes } from 'routes'
import { customerService, passwordService } from 'services'
import { RESET_PASSWORD_PAGE_PATH, routes } from 'routes/routes'
import keycloak from './keycloack'
import { store } from './store'

function App() {
  const { isRemindPasswordLater } = useRemindPasswordLater()
  const history = useHistory()
  const currentRoute = routes.find(route =>
    matchPath(history.location.pathname, {
      ...route,
    })
  )
  const { sendLoginEvent } = useFirebaseLogin()
  const { getRequiredPasswordUpdate } = passwordService()
  const { getCustomer } = customerService()

  function handleRedirect(pathname, search = null) {
    history.push({
      pathname,
      search,
    })
  }

  async function getIsFirstAccess() {
    try {
      const { data } = await getCustomer()
      sendLoginEvent(data.document)

      const { search } = history.location

      if (data.isFirstAccess) handleRedirect(RESET_PASSWORD_PAGE_PATH)
      else if (currentRoute?.privateRoute && !isRemindPasswordLater) {
        const {
          data: { shouldChangePassword },
        } = await getRequiredPasswordUpdate(ORIGIN)

        if (shouldChangePassword) handleRedirect(ROUTES.REQUIRED_PASSWORD_UPDATE.PATH)
        else handleRedirect(ROUTES.HOME.PATH, search)
      }
    } catch (error) {
      console.error(error)
    }
  }

  function handleOnAuthSuccessEvent(event) {
    if (event === AUTH_SUCCESS_EVENT) {
      localStorage.setItem('SUMICITY_SESSION_TIME', Date.now())

      getIsFirstAccess()
    }
  }

  function renderContent() {
    return (
      <KeycloakProvider
        keycloak={keycloak}
        initConfig={{
          checkLoginIframe: false,
        }}
        onTokens={tokens => {
          if (tokens.token) {
            localStorage.setItem(JWT_TOKEN_KEY, tokens.token)
          }
        }}
        onEvent={event => handleOnAuthSuccessEvent(event)}
      >
        <Provider store={store}>
          <Routes />
          <Drawer />
          <Modal />
        </Provider>
      </KeycloakProvider>
    )
  }

  return renderContent()
}

export default App
